import {
  ActiveTab,
  TabProps,
} from '../../../../features/layout/screens/MainLayoutScreen/MainLayoutScreenProps';
import { menuTabs } from './constants/mainLayout.constant';
import ScannerIcon from '../../../../shared/assets/icons/ScannerIcon';
import WorkOrdersIcon from '../../../../shared/assets/icons/WorkOrdersIcon';
import DashboardMenuIcon from '@shared/assets/icons/DashboardMenuIcon';
import PartsIcon from '@shared/assets/icons/PartsIcon';
import HelperIcon from '@shared/assets/icons/HelperIcon';
import HomeIcon from '@shared/assets/icons/HomeIcon';
import RepairsIcon from '@shared/assets/icons/RepairsIcon';
import RepairsMainIcon from '@shared/assets/icons/RepairsMainIcon';

/**
 * This method is used to prepare tabs [eg: Home, Parts etc..]
 * @param {t} - Translation key
 * @returns
 */
export const prepareTabs = (t: any): TabProps[] => {
  const tabs: TabProps[] = [
    {
      key: menuTabs.home,
      label: t('mainLayout.home'),
      icon: HomeIcon,
    },
    {
      key: menuTabs.repairs,
      label: t('mainLayout.repairs'),
      icon: RepairsMainIcon,
    },
    {
      key: menuTabs.parts,
      label: t('mainLayout.parts'),
      icon: PartsIcon,
    },
    // {
    //   key: menuTabs.VINScanner,
    //   label: t('mainLayout.VINscanner'),
    //   icon: ScannerIcon,
    // },

    // {
    //   key: menuTabs.profile,
    //   label: t('mainLayout.profile'),
    //   icon: ProfileIcon,
    // },
  ];
  return tabs?.map(tab => {
    return {
      key: tab.key as ActiveTab,
      label: tab.label,
      icon: tab.icon,
    };
  });
};

/**
 * This method is used to prepare lower menu tabs [eg: Notifications, Help, Profile etc..]
 * @param {t} - Translation key
 * @returns
 */
export const prepareLowerMenuTabs = (): TabProps[] => {
  const tabs: TabProps[] = [
    // {
    //   key: menuTabs.notifications,
    //   icon: NotificationMenuIcon,
    // },
    {
      key: menuTabs.help,
      icon: HelperIcon,
    },
    //  {
    //   key: menuTabs.logOut,
    //   icon: LogoutIcon,
    // },
  ];
  return tabs?.map(tab => {
    return {
      key: tab.key as ActiveTab,
      label: tab.label,
      icon: tab.icon,
    };
  });
};

export const getInitials = (userName: string) => {
  if (!userName) return '';
  const parts = userName.trim().split(' ');
  return parts.length > 1
    ? (parts[0][0] + parts[parts.length - 1][0])?.toUpperCase()
    : parts[0][0]?.toUpperCase();
};
